<template lang="html">
    <fleets v-if="displayFleetsPageWhenNoSelectedFleet"></fleets>
    <simple-layout
        v-else
        class="requests-home-page"
        :indicators="simpleLayoutIndicators"
        :modelsLoaded="true"
    >
        <el-row>
            <el-col :span='16'><h1>Requêtes d'inspection</h1></el-col>
            <el-col :span='8'>
                <select-group v-if="displaySelectGroup" class="select-group-component"></select-group>
            </el-col>
        </el-row>
        <div class="page-description">
            <p>
                Gérer vos requêtes d'inspection avec les boutons d'action.
            </p>
            <div>
                <span v-if="userIsClient">
                    <el-icon class="el-icon-check success"></el-icon>
                    <span>Confirmer une inspection</span>
                </span>
                <span>
                    <i class="ti-calendar primary"></i>
                    <span>Reprogrammer une requête d'inspection</span>
                </span>
                <span v-if="userIsClient">
                    <el-icon class="el-icon-delete danger"></el-icon>
                    <span>Annuler une inspection</span>
                </span>
                <span>
                    <i class="ti-comment-alt primary"></i>
                    <span>Ajouter un commentaire</span>
                </span>
            </div>
           
        </div>
        <ns-vue-loader
            :toLoad="requiredData"
            @dataFetched="onDataFetched"
            ref="nsLoader"
            class="requests-table"
        >
            <div slot="content" v-if="contentLoaded">
                 <div v-if="dateExist">
                    <p>Dernière synchronisation le {{ generalParameters[0].value.date | moment("DD/MM/YY à HH:mm")}}</p>
                </div>
                <h2>Requêtes d'inspection en attente d'une réponse</h2>
                <requests-table
                    :answered="false"
                    :vehicles="vehicles"
                    :inspectionRequests="inspectionRequests"
                >
                </requests-table>
                <h2>Requêtes d'inspection répondues</h2>
                <requests-table
                    :answered="true"
                    :vehicles="vehicles"
                    :inspectionRequests="inspectionRequestsAnswered"
                >
                </requests-table>
            </div>
        </ns-vue-loader>
    </simple-layout>
</template>

<script>
import RequestsTable from './requests-table.vue';
import SelectGroup from '@/components/partials/select-group.vue';
import Fleets from '../Fleets/Index.vue';
import { mapGetters } from 'vuex';
import {EventBus} from '@/event-bus.js';
import NsVueLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader.vue';
import moment from 'moment';



export default {

    components: {
        RequestsTable,
        SelectGroup,
        Fleets,
        NsVueLoader
    },

    data () {
        return {
            contentLoaded: false,
            vehicles: [],
            inspectionRequests: [],
            inspectionRequestsAnswered: [],
            requiredData: [
                {
                    name: 'inspectionRequests',
                    model: 'inspectionRequests',
                    filters: {
                        // client_has_answered: this.answered,
                        // CLE leave the getter without mapGetter or else requests are not showing
                        client_group: this.$store.getters.getSelectedFleet,
                        ordering: 'scheduled_date_start',
                        archived: false,
                    },
                },
                {
                    name: 'vehicles',
                    model: 'vehicles',
                    filters: {
                        client_group: this.$store.getters.getSelectedFleet,
                        ordering: 'last_inspection_date',
                        out_of_fleet: false
                    },
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'displayFleetsPage',
            'isAFleetSelected',
            'displaySelectGroup',
            'simpleLayoutIndicators',
            'generalParameters',
        ]),

        userIsClient() {
            return this.$store.getters.currentUser.is_client;
        },

        displayFleetsPageWhenNoSelectedFleet() {
            return this.displayFleetsPage && !this.isAFleetSelected;
        },
        dateExist(){
            if( this.generalParameters.length === 0){
                return false
            }else {
                return true
            }
        }
    },
    watch: {
        '$store.getters.getSelectedFleet'(val) {
            this.$set(this.requiredData[0].filters, 'client_group', val);
            this.$set(this.requiredData[1].filters, 'client_group', val);
            this.refreshData();
        },
    },

    mounted() {
        EventBus.$on('refreshTable', this.refreshData);
    },
    methods: {
        onDataFetched (response){
            this.$set(this, 'inspectionRequests', response.inspectionRequests.filter(ir => ir.client_has_answered === false && ir.archived === false));
            this.$set(this, 'inspectionRequestsAnswered', response.inspectionRequests.filter(ir => ir.client_has_answered === true && ir.archived === false));
            this.$set(this, 'vehicles', response.vehicles);
            this.contentLoaded = true;
        },
        refreshData() {
            if(this.$refs['nsLoader']) {
                this.$refs['nsLoader'].triggerRefresh(true);
            }
        },

    }
};
</script>

<style lang="scss">
.requests-home-page {

    .page-description {
        margin-bottom: 20px;

        .primary {
            color: #409EFF;
            margin-left: 10px;
        }

        .success {
            color: #67C23A;
            margin-left: 10px;
        }

        .danger {
            color: #F56C6C;
            margin-left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/Index.vue